import { render, staticRenderFns } from "./ImageViewsIndicator.vue?vue&type=template&id=45ac76dc&"
import script from "./ImageViewsIndicator.vue?vue&type=script&lang=js&"
export * from "./ImageViewsIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports